import { BirdviewState } from '../../../DashboardBirdview'

import {
  OVERVIEW_PANEL_LIST,
  OVERVIEW_PANEL_ROW_KEY_SEPARATOR,
} from './RentalPortalOverviewPanels.constants'

export function getOverviewPanelState({ isLoading, rows }) {
  if (isLoading) {
    return BirdviewState.Loading
  }

  if (!Array.isArray(rows)) {
    return BirdviewState.Error
  }

  return rows.length > 0 ? BirdviewState.Normal : BirdviewState.Empty
}

export function getOverviewPanelRowKey({ row, rowKeyFields }) {
  return rowKeyFields
    .map(field => row[field])
    .join(OVERVIEW_PANEL_ROW_KEY_SEPARATOR)
}

export function getOverviewPanelRows({ Row, rowKeyFields, rows }) {
  return Row
    ? rows?.map(row => (
        <Row key={getOverviewPanelRowKey({ row, rowKeyFields })} row={row} />
      ))
    : null
}

export function getOverviewPanelOverlayTitles(t) {
  return Object.fromEntries(
    OVERVIEW_PANEL_LIST.map(panel => [panel.field, t(panel.titleKey)])
  )
}

export function getIsOverviewPanelTruncated({ rows, total }) {
  return total > (rows?.length ?? 0)
}
